<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.CheckingHistory')"
      width="1000px"
      :close-on-click-modal="false"
      class="app-main-inner"
    >
      <cargo-ag-grid
        config-module="240508"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:300px"
        @gridReady="params=>{gridApi=params.api}"
      />
      <span slot="footer">
        <el-button no="1" @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <show-message-dialog
      v-if="showMessage.visible"
      :visible.sync="showMessage.visible"
      :message-text="showMessage.messageText"
    />
  </div>
</template>

<script>
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import showMessageDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/showMessageDialog'

export default {
  name: 'MatchHistoryDialog',
  components: { showMessageDialog },
  props: {
    visible: { type: Boolean, required: true },
    cargoDocUuid: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      documentManage: new DocumentManage(),
      showMessage: {
        visible: false,
        messageText: ''
      },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Shipper'),
          field: 'shipperLine',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Consignee'),
          field: 'consigneeLine',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_NotifyParty'),
          field: 'notifyLine',
          width: 100
        }, {
          headerName: this.$t('SeaExport.NoOfOriginalBls'),
          field: 'BLNumber',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Package'),
          field: 'packing',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_InsideQuantity'),
          field: 'insideQuantity',
          width: 100
        }, {
          headerName: this.$t('SeaExport.PiecesType'),
          field: 'insidePacking',
          width: 100
        }, {
          headerName: this.$t('SeaExport.PlaceOfReceiptOnBl'),
          field: 'dispatchingPlace',
          width: 100
        }, {
          headerName: this.$t('SeaExport.NumberOfPackagesOnBl'),
          field: 'quantity',
          width: 100
        }, {
          headerName: this.$t('SeaExport.HBLWeight'),
          field: 'weight',
          width: 100
        }, {
          headerName: this.$t('SeaExport.VolumeOnBl'),
          field: 'cubage',
          width: 100
        }, {
          headerName: this.$t('SeaExport.PortOfLoadingOnBl'),
          field: 'loadingPort',
          width: 100
        }, {
          headerName: this.$t('SeaExport.PortOfDischargeOnBl'),
          field: 'dischargingPort',
          width: 100
        }, {
          headerName: this.$t('SeaExport.PlaceOfDeliveryOnBl'),
          field: 'destinationPort',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
          field: 'cargoEnglishName',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Marks'),
          field: 'mark',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContainerSize'),
          field: 'eqSizeModify',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContainerType'),
          field: 'eqTypeModify',
          width: 100
        }, {
          headerName: this.$t('SeaExport.ContainerWeight'),
          field: 'containerWeightModify',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContainerNo'),
          field: 'containerNoModify',
          width: 100
        }, {
          headerName: this.$t('SeaExport.SealNo'),
          field: 'sealNoModify',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
          field: 'quantityModify',
          width: 100
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weightModify',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Cubage'),
          field: 'cubageModify',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_DataModifyDate'),
          field: 'dateModified',
          width: 100,
          valueFormatter: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_DataSource'),
          field: 'dataSources',
          width: 100,
          valueFormatter: params => {
            if (params.value === 'B2B') {
              return 'B2B'
            } else {
              return 'Super Link'
            }
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OriginalMessage'),
          field: 'jsonMessage',
          width: 100,
          cellRenderer: (params) => {
            if (!params.data) {
              return ''
            }
            const uuid = params.data.UUID
            const timestamp = params.data.timestamp
            const methodOnFileViewPath = this.documentManage.getPath('onView')
            return `<a onclick="${methodOnFileViewPath}('${uuid}','${timestamp}')" style="color:blue">
                    ${this.$t('CargoMsg.Cargo_View')}
                    </a>`
          }
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onView', function(value, timestamp) {
      context.onView(value, timestamp)
    })
  },
  methods: {
    onView(value, timestamp) {
      if (value && timestamp) {
        CheckCargoDocHistory.queryDocHistoryJsonFunc(value, timestamp).then(data => {
          this.showMessage.visible = true
          this.showMessage.messageText = data
        })
      }
    },
    toQuery() {
      if (this.cargoDocUuid) {
        CheckCargoDocHistory.queryDocHistory(this.cargoDocUuid).then(data => {
          this.rowData = data
        })
      } else {
        this.rowData = []
      }
    }
  }
}
</script>

<style>
</style>
